<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Auth'
};
</script>

<style></style>
